import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import header from './module/header'
import question from './module/question'
const store = new Vuex.Store({
    modules: {
        header: header,
        question,
    }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js